<template>
  <div>
    <v-btn
      color="success"
      class="mt-3"
      small
      @click="openNewPaymentPickupDialog"
      >New Payment Pickup</v-btn
    >
    <v-progress-linear
      v-if="loading"
      :indeterminate="true"
      color="success"
    ></v-progress-linear>
    <v-layout
      v-if="!loading && !pickups.length"
      justify-center
      align-center
      class="my-4 headline"
    >
      No Pickups
    </v-layout>
    <div class="mt-2">
      <v-expansion-panel
        v-model="pickupExpandedIndex"
        class="expansion-panel-margin"
      >
        <v-expansion-panel-content v-for="pickup in pickups">
          <template v-slot:header>
            <v-flex xs3>
              <v-layout row align-start class="pa-0 mx-0">
                <v-layout column class="py-0 ma-0">
                  <v-flex xs3>
                    <v-layout row>
                      <v-icon
                        class="mr-3 ml-1"
                        dark
                        :color="getStatusIconColor(pickup)"
                        >{{ getStatusIcon(pickup) }}</v-icon
                      >
                      <div>
                        <div class="subheading mb-1">
                          {{ pickup.pickupDate | date }}
                        </div>
                        <div class="text--disabled subheading">
                          {{ pickup.status }}
                        </div>
                      </div>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs2>
              <div class="body-2 font-weight-medium mb-1">
                Messenger:
              </div>
              <div class="body-2 mb-1">
                {{
                  getMessangerName(pickup.messengerID)
                    ? getMessangerName(pickup.messengerID)
                    : "Unassigned"
                }}
              </div>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs3>
              <v-layout column align-end class="mx-0 pr-4">
                <div class="subheading mb-1">
                  {{ pickup.amount | currency }}
                </div>
                <div class="text--disabled subheading">
                  {{ pickup.pickupAddress }}
                </div>
              </v-layout>
            </v-flex>
          </template>
          <v-card>
            <v-flex xs12>
              <v-layout row>
                <v-flex xs6>
                  <v-card-text class="subheading mt-2" style="height: 326px">
                    <v-layout row class="px-3 py-1">
                      <div class="font-weight-medium mr-2 width-200">
                        Pickup Date:
                      </div>
                      <div>
                        {{ pickup.pickupDate | date }}
                      </div>
                    </v-layout>
                    <v-layout row class="px-3 py-1">
                      <div class="font-weight-medium mr-2 width-200">
                        Amount:
                      </div>
                      <div>
                        {{ pickup.amount | currency }}
                      </div>
                    </v-layout>
                    <v-layout row class="px-3 py-1">
                      <div class="font-weight-medium mr-2 width-200">
                        Pickup Address:
                      </div>
                      <div>
                        {{ pickup.pickupAddress }}
                      </div>
                    </v-layout>
                    <v-layout row class="px-3 py-1">
                      <div class="font-weight-medium mr-2 width-200">
                        Messenger Name:
                      </div>
                      <div>
                        {{ getMessangerName(pickup.messengerID) }}
                      </div>
                    </v-layout>
                    <v-layout row class="px-3 py-1">
                      <div class="font-weight-medium mr-2 width-200">
                        Messenger Phone #:
                      </div>
                      <div>
                        {{ pickup.messengerPhone | phone }}
                      </div>
                    </v-layout>
                    <v-layout row class="px-3 py-1">
                      <div class="font-weight-medium mr-2 width-200">
                        Status:
                      </div>
                      <div>
                        {{ pickup.status }}
                      </div>
                    </v-layout>
                    <v-layout row class="px-3 py-1">
                      <div class="font-weight-medium mr-2 width-200">
                        Entered By:
                      </div>
                      <div>
                        {{ pickup.enteredBy }}
                      </div>
                    </v-layout>
                    <v-layout row class="px-3 py-1">
                      <div class="font-weight-medium mr-2 width-200">
                        Entered On:
                      </div>
                      <div>
                        {{ pickup.enteredOn | time }}
                      </div>
                    </v-layout>
                    <v-layout row class="px-3 py-1" v-if="pickup.note">
                      <div class="font-weight-medium mr-2 width-200">
                        Note:
                      </div>
                      <div>
                        {{ pickup.note }}
                      </div>
                    </v-layout>
                    <v-layout row class="px-3 py-1" v-if="pickup.updatedBy">
                      <div class="font-weight-medium mr-2 width-200">
                        Updated By:
                      </div>
                      <div>
                        {{ pickup.updatedBy }}
                      </div>
                    </v-layout>
                    <v-layout row class="px-3 py-1" v-if="pickup.updatedAt">
                      <div class="font-weight-medium mr-2 width-200">
                        Updated At:
                      </div>
                      <div>
                        {{ pickup.updatedAt | time }}
                      </div>
                    </v-layout>
                  </v-card-text>

                  <v-card-actions class="pb-0 pt-4 mt-2">
                    <v-btn
                      small
                      color="warning"
                      class="mr-2"
                      v-on:click="openDeleteDialog(pickup)"
                    >
                      Delete
                    </v-btn>
                    <v-btn
                      small
                      class="mx-0"
                      color="success"
                      v-on:click="editPickup(pickup)"
                    >
                      Update
                    </v-btn>
                  </v-card-actions>
                </v-flex>
                <v-flex xs6 class="mr-4 my-2">
                  <div
                    class="account-pickup-messages-scroll-down elevation-0"
                    style="background-color: #f1ffdc"
                  >
                    <v-timeline
                      dense
                      class="petition-timeline mx-3"
                      style=""
                      v-if="
                        messages.filter((m) => m.paymentPickupID == pickup.id)
                          .length && !loading
                      "
                    >
                      <div
                        v-for="message in messages.filter(
                          (m) => m.paymentPickupID == pickup.id
                        )"
                      >
                        <v-timeline-item color="rgb(92, 184, 96)">
                          <v-card>
                            <v-card-title
                              style="background-color: rgb(92, 184, 96)"
                              class=" py-1"
                            >
                              <h2
                                class="body-1 my-0 white--text font-weight-light"
                              >
                                <div>
                                  <v-icon dark size="15" class="mr-2">
                                    mdi-laptop-windows
                                  </v-icon>
                                  {{ message.dateTime | time }}
                                  {{ " - " + message.username }}
                                </div>
                                <div>
                                  FROM:
                                  {{ message.from | phone }}
                                  TO:
                                  {{ message.to | phone }}
                                </div>
                              </h2>
                            </v-card-title>
                            <v-container class="pa-3">
                              <v-layout class="px-2 pt-1">
                                <v-flex
                                  xs10
                                  class="py-0 body-2 account-message-text"
                                >
                                  {{ message.text }}
                                </v-flex>
                              </v-layout>
                              <v-layout row justify-end style="font-size: 11px">
                                <v-spacer></v-spacer>
                                <div
                                  class="text-xs-right px-2 account-message-status"
                                  style=""
                                >
                                  {{ message.status }}
                                </div>
                              </v-layout>
                            </v-container>
                          </v-card>
                        </v-timeline-item>
                      </div>
                    </v-timeline>
                  </div>
                  <v-divider></v-divider>
                  <v-layout row class="mx-1 mt-1">
                    <v-textarea
                      class="mr-1"
                      hide-details
                      label="Type a Message..."
                      v-model="newMessage"
                      ref="newMessage"
                      rows="1"
                    ></v-textarea>
                    <v-btn
                      @click="sendMessage(pickup)"
                      :disabled="disableSend()"
                      :loading="sending"
                      class="mb-1"
                      color="success"
                    >
                      <v-icon>mdi-send</v-icon>
                    </v-btn>
                  </v-layout>

                  <v-layout row class="mb-2 pl-3">
                    <div class="font-weight-medium mr-2">
                      From:
                    </div>
                    <div class="font-weight-light mr-2">
                      {{ fromPhone | phone }}
                    </div>
                    <div class="font-weight-medium mr-2">
                      To:
                    </div>
                    <div class="font-weight-light">
                      {{ toPhone | phone }}
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>

    <v-dialog persistent v-model="newPaymentPickupDialog" max-width="800">
      <v-card class="pa-3">
        <div class="headline mb-3">New Payment Pickup</div>

        <v-layout row>
          <v-layout column xs6 class="mx-2">
            <v-menu
              v-model="newPaymentPickup.datePickerMenu"
              :close-on-content-click="true"
              offset-y
              full-width
              prepend-icon="mdi-currency-usd"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="newPaymentPickup.pickupDate"
                  :value="newPaymentPickup.pickupDate"
                  label="Pickup Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="newPaymentPickup.pickupDate"
              ></v-date-picker>
            </v-menu>
            <v-text-field
              class="pt-2"
              prepend-icon="mdi-currency-usd"
              v-model="newPaymentPickup.amount"
              label="Amount"
              type="number"
              ref="amount"
            ></v-text-field>
            <v-select
              v-model="newPaymentPickup.messengerName"
              label="Messenger"
              :items="messengers.map((m) => m.displayName)"
              @change="onMessengerSelected"
            ></v-select>
            <v-layout row class="pa-0">
              <!-- <div class="mb-0 mt-1">
                                Messanger Phone:
                                {{ newPaymentPickup.messengerPhone | phone }}
                            </div> -->
              <v-spacer></v-spacer>
              <v-btn
                class="mt-0"
                color="success"
                v-if="newPaymentPickup.messengerName"
                small
                @click="openMessengerDialog(newPaymentPickup.messengerName)"
                >Update</v-btn
              >
              <v-btn
                class="mt-0"
                color="success"
                small
                @click="openMessengerDialog()"
                >Add New</v-btn
              >
            </v-layout>
            <v-text-field
              v-model="newPaymentPickup.pickupAddress"
              label="Pickup Address"
            ></v-text-field>
            <v-select
              hide-details
              class="mb-2"
              v-model="newPaymentPickup.accountPhones"
              multiple
              label="Select Phone Number"
              autocomplete="new-password"
              :items="getAccountPhones()"
            ></v-select>
            <v-text-field
              v-model="newPaymentPickup.accountPhone"
              label="Type Phone Number"
            ></v-text-field>
            <!-- <div style="font-size: 13px">
                            {{ getPhoneType(newPaymentPickup.accountPhone) }}
                        </div> -->
          </v-layout>
          <v-layout column fill-height xs6 class="mx-2">
            <!-- <v-select
                            :rules="[rules.required]"
                            ref="status"
                            v-model="newPaymentPickup.status"
                            label="Status"
                            :items="['Pending', 'Completed']"
                        ></v-select> -->
            <v-textarea
              class="mb-3"
              outline
              hide-details
              rows="2"
              label="Note"
              v-model="newPaymentPickup.note"
            ></v-textarea>

            <div style=" border: 2px solid #5cb860;">
              <div
                class="font-weight-medium white--text pa-1"
                style="background-color: #5cb860;"
              >
                Text Message:
              </div>
              <div
                class="px-2 pb-2"
                style="white-space: pre-line; margin-top: -18px;"
              >
                {{ getTextMessage() }}
              </div>
            </div>

            <v-text-field
              class="mt-3"
              :rules="[rules.email]"
              label="Email"
              ref="emailTo"
              v-model="newPaymentPickup.emailTo"
            ></v-text-field>
          </v-layout>
        </v-layout>

        <v-card-actions class="mr-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="closeNewPaymentPickupDialog"
            >Cancel</v-btn
          >
          <v-btn color="success" @click="save" :loading="processing"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="updatePickupDialog" max-width="400">
      <v-card class="pa-3">
        <div class="headline mb-3">Update Payment Pickup</div>
        <v-menu
          v-model="pickupToUpdate.datePickerMenu"
          :close-on-content-click="true"
          offset-y
          full-width
          prepend-icon="mdi-currency-usd"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="pickupToUpdate.pickupDate"
              :value="pickupToUpdate.pickupDate"
              label="Pickup Date"
              prepend-icon="mdi-calendar"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="pickupToUpdate.pickupDate"></v-date-picker>
        </v-menu>
        <v-text-field
          class="pt-2"
          prepend-icon="mdi-currency-usd"
          v-model="pickupToUpdate.amount"
          label="Amount"
          type="number"
          ref="pickupAmount"
        ></v-text-field>
        <v-select
          v-model="pickupToUpdate.messengerName"
          label="Messenger"
          :items="messengers.map((m) => m.displayName)"
          @change="onMessengerSelected(pickupToUpdate.messengerName, true)"
        ></v-select>
        <v-layout row class="pa-0">
          <!-- <div class="mb-0 mt-1">
                        Messanger Phone:
                        {{ pickupToUpdate.messengerPhone | phone }}
                    </div> -->
          <v-spacer></v-spacer>
          <v-btn
            class="mt-0"
            color="success"
            small
            v-if="pickupToUpdate.messengerName"
            @click="openMessengerDialog(pickupToUpdate.messengerName)"
            >Update</v-btn
          >
          <v-btn
            class="mt-0"
            color="success"
            small
            @click="openMessengerDialog()"
            >Add New</v-btn
          >
        </v-layout>
        <v-text-field
          v-model="pickupToUpdate.pickupAddress"
          label="Pickup Address"
        ></v-text-field>
        <v-textarea
          outline
          rows="2"
          label="Note"
          v-model="pickupToUpdate.note"
        ></v-textarea>
        <v-select
          :rules="[rules.required]"
          ref="pickupStatus"
          v-model="pickupToUpdate.status"
          label="Status"
          :items="['Pending', 'Completed']"
        ></v-select>

        <v-card-actions class="mr-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="updatePickupDialog = false"
            >Cancel</v-btn
          >
          <v-btn :loading="processing" color="success" @click="updatePickup"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="deleteDialog" max-width="400">
      <v-card class="pa-2">
        <v-card-title class="text-warning headline pt-2"
          >Are You Sure?</v-card-title
        >
        <v-card-text class="mb-3 py-0">
          You will now delete the payment pickup scheduled for
          {{ pickupToDelete.pickupDate | date }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="deleteDialog = false"
            >Close</v-btn
          >
          <v-btn :loading="processing" color="warning" @click="deletePickup()"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="messengerDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="pl-0 headline pt-2">Messenger</v-card-title>
        <v-text-field
          v-model="messengerToUpdate.name"
          label="Name"
          ref="messengerName"
          :rules="[rules.required]"
        ></v-text-field>
        <v-text-field
          v-model="messengerToUpdate.number"
          label="Number"
          ref="messengerPhone"
          :rules="[rules.required, rules.phoneNumber]"
        ></v-text-field>
        <v-card-actions class="mr-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="messengerDialog = false"
            >Close</v-btn
          >
          <v-btn
            v-if="messengerToUpdate.id"
            color="warning"
            @click="deleteMessenger()"
            >Delete</v-btn
          >
          <v-btn :loading="processing" color="success" @click="saveMessenger()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  formatPhoneNumber,
  sum,
  toISOLocal,
  formatCurrency,
} from "../../utils/helpers.js";
import moment from "moment";

export default {
  props: {
    accountID: String,
    account: Object,
    accountPhones: Array,
  },
  data() {
    return {
      pickups: [],
      processing: false,
      newPaymentPickupDialog: false,
      updatePickupDialog: false,
      deleteDialog: false,
      pickupToDelete: "",
      pickupToUpdate: "",
      messengers: [],
      loading: true,

      messages: [],
      newMessage: "",
      sending: false,
      fromPhone: "18775447264",
      toPhone: "",
      fromPhones: [],

      messengerDialog: false,
      messengerToUpdate: {
        id: 0,
        name: "",
        number: "",
      },

      pickupExpandedIndex: null,
      user: "",

      newPaymentPickup: {
        amount: "",
        pickupDate: toISOLocal(new Date(moment())).substr(0, 10),
        pickupAddress: "",
        note: "",
        phone: "",
        messengerID: "",
        messengerName: "",
        messengerPhone: "",
        accountPhones: "",
        accountPhone: "",
        status: "Pending",
        datePickerMenu: false,
        emailTo: "",
      },

      rules: {
        required: (value) => !!value || "Required.",
        phoneNumber: (v) => {
          return (
            !v ||
            ([10, 11].includes(v.replace(/-/g, "").length) &&
              /^\d+$/.test(v.replace(/-/g, ""))) ||
            "Invalid Phone Number"
          );
        },
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return !value || pattern.test(value) || "Invalid e-mail.";
        },
      },
    };
  },
  watch: {
    pickupExpandedIndex(newValue) {
      this.onExpended(newValue);
    },
  },
  async created() {
    await this.loadMessengers();
    await this.loadPickups();
    this.loadDefaultEmail();
    this.loadFromPhones();

    this.user = this.$store.state.authentication.user;

    if (this.$route.query.paymentPickupID) {
      const pickup = this.pickups.find(
        (p) => p.id == this.$route.query.paymentPickupID
      );

      const index = this.pickups.indexOf(pickup);

      this.pickupExpandedIndex = index;
    }
  },
  mounted() {},
  beforeDestroy() {},
  computed: {},
  methods: {
    async loadPickups() {
      const pickups = await this.$http.get(
        "api/paymentpickup/GetForAccount?accountID=" + this.accountID
      );

      this.pickups = pickups.map((pickup) => {
        const messenger = this.messengers.find(
          (m) => m.id == pickup.messengerID
        );

        pickup.messengerName = messenger ? messenger.displayName : "";
        pickup.messengerPhone = messenger ? messenger.number : "";

        return pickup;
      });
      this.loading = false;

      this.newPaymentPickup.pickupAddress = this.account.address1;
      this.newPaymentPickup.accountPhones = this.getAccountPhones();
      this.newPaymentPickup.accountPhone = "";

      this.loadMessages();
    },
    getHomePhone() {
      const homePhone = this.getAccountPhones().find((p) =>
        p.startsWith("PHON")
      );

      return homePhone ? homePhone : this.getAccountPhones()[0];
    },
    async loadMessengers() {
      const messengers = await this.$http.get(
        "api/paymentpickup/GetMessangers"
      );

      this.messengers = messengers.map((messenger) => {
        messenger.displayName = messenger.name + " (" + messenger.number + ") ";

        return messenger;
      });
    },
    async loadMessages() {
      const messages = await this.$http.post(
        "api/paymentpickup/GetPickupMessages",
        this.pickups.map((p) => p.id)
      );

      this.messages = messages;
    },
    getMessangerName(messengerID) {
      const messenger = this.messengers.find((m) => m.id == messengerID);

      if (!messenger) return "";

      return messenger.name;
    },
    getStatusIconColor(pickup) {
      if (pickup.status == "Pending") return "#fdb400";
      if (pickup.status == "Completed") return "success";

      return "#aeb8bf";
    },
    getStatusIcon(pickup) {
      if (pickup.status == "Pending") return "mdi-clock";
      if (pickup.status == "Completed") return "mdi-check-circle";

      return "#aeb8bf";
    },
    onExpended(index) {
      const pickup = this.pickups[index];

      this.toPhone = pickup ? pickup.messengerPhone : "";
    },
    openDeleteDialog(pickup) {
      this.pickupToDelete = pickup;
      this.deleteDialog = true;
    },
    onMessengerSelected(value, isUpdate = false) {
      const parts = value.split(" (");
      const name = parts[0];
      const messenger = this.messengers.find((m) => m.name == name);

      this.toPhone = messenger.number;

      if (isUpdate) {
        this.pickupToUpdate.messengerID = messenger ? messenger.id : "";
        this.pickupToUpdate.messengerPhone = messenger ? messenger.number : "";
        this.pickupToUpdate.messengerName = messenger
          ? messenger.displayName
          : "";
      } else {
        this.newPaymentPickup.messengerID = messenger ? messenger.id : "";
        this.newPaymentPickup.messengerPhone = messenger
          ? messenger.number
          : "";
        this.newPaymentPickup.messengerName = messenger
          ? messenger.displayName
          : "";
      }
    },
    openMessengerDialog(displayName) {
      let messenger = null;

      if (displayName) {
        const parts = displayName.split(" (");
        const name = parts[0];

        messenger = this.messengers.find((m) => m.name == name);
      }

      if (messenger) {
        this.messengerToUpdate.id = messenger.id;
        this.messengerToUpdate.name = messenger.name;
        this.messengerToUpdate.number = messenger.number;
      } else {
        this.messengerToUpdate.id = 0;
        this.messengerToUpdate.name = "";
        this.messengerToUpdate.number = "";
      }

      this.messengerDialog = true;
    },
    async saveMessenger() {
      if (
        !this.$refs.messengerPhone.validate(true) ||
        !this.$refs.messengerName.validate(true)
      )
        return;

      try {
        this.processing = true;

        this.messengerToUpdate.number = this.messengerToUpdate.number.replace(
          /\D/g,
          ""
        );

        this.messengerToUpdate.number =
          this.messengerToUpdate.number.length == 10
            ? "1" + this.messengerToUpdate.number
            : this.messengerToUpdate.number;

        const response = await this.$http.post(
          "api/paymentPickup/saveMessenger",
          this.messengerToUpdate
        );

        this.processing = false;

        this.messengerDialog = false;

        this.loadPickups();
        await this.loadMessengers();

        const messenger = this.messengers.find((m) => m.id == response.id);

        if (this.updatePickupDialog) {
          this.pickupToUpdate.messengerID = messenger.id;
          this.pickupToUpdate.messengerPhone = messenger.number;
          this.pickupToUpdate.messengerName = messenger.displayName;
        } else {
          this.newPaymentPickup.messengerID = messenger.id;
          this.newPaymentPickup.messengerPhone = messenger.number;
          this.newPaymentPickup.messengerName = messenger.displayName;
        }
      } catch (e) {
        this.processing = false;
      }
    },
    async deleteMessenger() {
      try {
        this.processing = true;

        const response = await this.$http.post(
          "api/paymentPickup/DeleteMessenger?id=" + this.messengerToUpdate.id
        );

        this.processing = false;

        this.messengerDialog = false;

        if (this.updatePickupDialog) {
          this.pickupToUpdate.messengerID = "";
          this.pickupToUpdate.messengerPhone = "";
          this.pickupToUpdate.messengerName = "";
        } else {
          this.newPaymentPickup.messengerID = "";
          this.newPaymentPickup.messengerPhone = "";
          this.newPaymentPickup.messengerName = "";
        }

        return this.$notify({
          text: "Messenger Deleted",
          group: "notification",
          type: "success",
        });

        this.loadPickups();

        await this.loadMessengers();
      } catch (e) {
        this.processing = false;
      }
    },
    async deletePickup(pickup) {
      try {
        this.processing = true;

        await this.$http.post(
          "api/paymentPickup/Delete?id=" + this.pickupToDelete.id
        );

        this.processing = false;

        this.deleteDialog = false;

        this.loadPickups();
      } catch (e) {
        this.processing = false;
      }
    },
    editPickup(pickup) {
      this.pickupToUpdate = JSON.parse(JSON.stringify(pickup));
      this.pickupToUpdate.pickupDate = toISOLocal(
        new Date(this.pickupToUpdate.pickupDate)
      ).substr(0, 10);

      this.updatePickupDialog = true;
    },
    validateNewPickup() {
      return [
        this.$refs.amount.validate(true),
        this.$refs.emailTo.validate(true),
      ].every(Boolean);
    },
    async loadFromPhones() {
      this.fromPhones = await this.$http.get(
        "api/broadcast/getFromPhoneNumbers"
      );
    },
    async loadDefaultEmail() {
      this.newPaymentPickup.emailTo = await this.$http.get(
        "api/paymentPickup/getDefaultEmail"
      );
    },

    // onAccountPhoneChange(e) {
    //     if (!e) {
    //         this.newPaymentPickup.accountPhones = [""];
    //     } else {
    //         this.newPaymentPickup.accountPhones = [e.srcElement.value];
    //     }
    // },
    getPhoneType(phone) {
      if (!phone) return "";

      const accountPhone = this.accountPhones.find(
        (p) => p.phoneNum.replaceAll("-", "") == phone.replaceAll("-", "")
      );

      return accountPhone ? "Phone Type: " + accountPhone.phoneType : "";
    },
    getAccountPhones() {
      return this.accountPhones.map((p) => p.phoneType + ": " + p.phoneNum);
    },
    getTextMessage() {
      if (
        this.newPaymentPickup.pickupDate ||
        this.newPaymentPickup.pickupAddress ||
        this.newPaymentPickup.amount
      ) {
        return (
          "New Payment Pickup: " +
          "\n" +
          this.account.name +
          " - " +
          this.newPaymentPickup.pickupAddress +
          "\n" +
          "Contact: " +
          this.getPhonesText() +
          "Requester: " +
          this.user +
          (this.newPaymentPickup.pickupDate &&
          !this.isToday(this.newPaymentPickup.pickupDate)
            ? "\n" +
              " Date: " +
              moment(this.newPaymentPickup.pickupDate).format("L")
            : "") +
          (this.newPaymentPickup.amount
            ? "\n" + " Amount: " + formatCurrency(this.newPaymentPickup.amount)
            : "") +
          (this.newPaymentPickup.note
            ? "\n" + " Note: " + this.newPaymentPickup.note
            : "")
        );
      }

      return "";
    },
    getPhonesText() {
      let text = "";
      if (this.newPaymentPickup.accountPhones) {
        text = this.newPaymentPickup.accountPhones.join(", " + "\n") + "\n";
      }

      if (this.newPaymentPickup.accountPhone) {
        text += this.newPaymentPickup.accountPhone + "\n";
      }

      return text;
    },
    isToday(date) {
      return moment(date).isSame(new Date(), "day");
    },
    async save() {
      if (!this.validateNewPickup()) return;

      if (!this.newPaymentPickup.pickupDate) {
        return this.$notify({
          text: "Pickup Date Required",
          group: "notification",
          type: "error",
        });
      }

      if (!this.newPaymentPickup.messengerID) {
        return this.$notify({
          text: "Messenger Required",
          group: "notification",
          type: "error",
        });
      }

      try {
        this.processing = true;

        const pickup = await this.$http.post(
          "api/paymentPickup/savePaymentPickup",
          {
            pickup: {
              enteredBy: this.$store.state.authentication.user,
              accountID: this.account.accountID,
              pickupAddress: this.newPaymentPickup.pickupAddress,
              amount: this.newPaymentPickup.amount,
              pickupDate: this.newPaymentPickup.pickupDate,
              note: this.newPaymentPickup.note,
              messengerID: this.newPaymentPickup.messengerID,
              status: this.newPaymentPickup.status,
              phoneNumbers: this.newPaymentPickup.accountPhones.join("|"),
            },
            text: this.getTextMessage(),
            emailTo: this.newPaymentPickup.emailTo,
          }
        );

        this.newMessage = this.getTextMessage();
        this.fromPhone = "18775447264";
        this.toPhone = this.newPaymentPickup.messengerPhone;

        if (this.toPhone) {
          await this.sendMessage(pickup);
        }

        this.processing = false;

        this.closeNewPaymentPickupDialog();

        this.newPaymentPickup.pickupAddress = this.account.address1;
        this.newPaymentPickup.amount = "";
        this.newPaymentPickup.pickupDate = toISOLocal(
          new Date(moment())
        ).substr(0, 10);
        this.newPaymentPickup.note = "";
        this.newPaymentPickup.messengerName = "";
        this.newPaymentPickup.messengerID = "";
        this.newPaymentPickup.messengerPhone = "";

        this.newMessage = "";

        this.loadPickups();
      } catch (e) {
        this.processing = false;
      }
    },
    openNewPaymentPickupDialog() {
      this.newPaymentPickupDialog = true;
    },
    closeNewPaymentPickupDialog() {
      this.newPaymentPickupDialog = false;

      this.newPaymentPickup.pickupAddress = this.account.address1;
      this.newPaymentPickup.amount = "";
      this.newPaymentPickup.pickupDate = toISOLocal(new Date(moment())).substr(
        0,
        10
      );
      this.newPaymentPickup.note = "";
      this.newPaymentPickup.messenger = "";
      this.newPaymentPickup.messengerID = "";
      this.newPaymentPickup.messengerPhone = "";
    },
    formatPhoneNumber(number) {
      const value = number.length == 11 ? number.substring(1) : number;

      return formatPhoneNumber(value);
    },
    validatePickup() {
      return [
        this.$refs.pickupAmount.validate(true),
        this.$refs.pickupStatus.validate(true),
      ].every(Boolean);
    },
    async updatePickup() {
      if (!this.validatePickup()) return;

      if (!this.pickupToUpdate.pickupDate) {
        return this.$notify({
          text: "Pickup Date Required",
          group: "notification",
          type: "error",
        });
      }

      if (!this.pickupToUpdate.messengerID) {
        return this.$notify({
          text: "Messenger Required",
          group: "notification",
          type: "error",
        });
      }

      try {
        this.processing = true;

        const pickup = await this.$http.post(
          "api/paymentPickup/savePaymentPickup",
          {
            pickup: {
              id: this.pickupToUpdate.id,
              accountID: this.pickupToUpdate.accountID,
              pickupAddress: this.pickupToUpdate.pickupAddress,
              amount: this.pickupToUpdate.amount,
              pickupDate: this.pickupToUpdate.pickupDate,
              note: this.pickupToUpdate.note,
              messengerID: this.pickupToUpdate.messengerID,
              status: this.pickupToUpdate.status,
              updatedBy: this.$store.state.authentication.user,
            },
          }
        );

        this.processing = false;

        this.updatePickupDialog = false;

        this.loadPickups();
      } catch (e) {
        this.processing = false;
      }
    },
    disableSend() {
      return !this.newMessage.replace(/\r\n/g, "<br />").replace(/[\r\n]/g, "");
    },
    async sendMessage(pickup) {
      try {
        this.sending = true;

        await this.$http.post("api/paymentPickup/SendMessage", {
          from:
            typeof this.fromPhone == "string"
              ? this.fromPhone
              : this.fromPhone.number,
          to: this.toPhone.length == 11 ? this.toPhone : "1" + this.toPhone,
          paymentPickupID: pickup.id,
          text: this.newMessage,
          user: this.$store.state.authentication.user,
        });

        this.newMessage = "";

        this.sending = false;

        this.loadMessages();
      } catch (e) {
        this.sending = false;
      }
    },
  },
};
</script>
<style>
.toggle-button {
  font-size: 15px;
  padding: 5px !important;
}
.toggle-button-group {
  border-radius: 10px;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active {
  background-color: #afecb2 !important;
  color: #4caf50 !important;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active.rewards-history-button {
  border-radius: 10px 0px 0px 10px;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active.rewards-earn-button {
  border-radius: 0px 10px 10px 0px;
}
.account-pickup-messages-scroll-down {
  overflow-y: auto;
  height: 300px;
  display: flex;
  flex-direction: column-reverse;
}
.account-message-text {
  white-space: pre-line;
  margin-top: -20px;
}
.account-message-status {
  width: fit-content;
  background-color: purple;
  color: #fff;
  font-size: 11px;
  text-transform: uppercase;
}

.account-message-status-pending {
  background-color: rgb(253, 180, 0);
  cursor: pointer;
}

.account-message-status-completed {
  background-color: rgb(92, 184, 96);
}
</style>
